import { I18nComponente } from "@/types/gerais"

export const TProjetosi18n: I18nComponente = {
  "pt-BR": {
    projetos: "projetos",
    todosOsProjetos: "todos os projetos",
    criarGrupo: "criar grupo",
    criarProjeto: "criar projeto",
    cancelar: "cancelar",
    deletar: "deletar",
    voltarEditar: "voltar e editar",
    simCancelar: "sim, cancelar",
    aoCancelarEdicaoAsAlteracoesFeitasNoGrupoSeraoPerdidas: "Ao cancelar a edição, as alterações feitas no grupo serão perdidas.",
    cancelarEdicaoDoGrupoDeProjetos: "cancelar edição do grupo de projetos?",
    naoFoiPossivelBuscarOsGruposDeProjetos: "Não foi possível buscar os grupos de projetos",
    deletarGrupoDeProjetos: "deletar grupo de projetos?",
    apenasGrupoSeraDeletado: "Apenas o grupo será deletado – os projetos continuarão ativos no sistema.",
    naoFoiPossivelDeletarGrupoDeProjetos: "Não foi possível deletar o grupo de projetos",
    grupoDeProjetosDeletados: "Grupo de projetos deletado!",
    vejaSeusProjetosEm: `Veja seus projetos em "ver todos os projetos"`,
  },
  "es-CO": {
    projetos: "proyectos",
    todosOsProjetos: "todos los proyectos",
    criarGrupo: "añadir grupo",
    criarProjeto: "añadir proyecto",
    cancelar: "cancelar",
    deletar: "borrar",
    voltarEditar: "volver y editar",
    simCancelar: "sí, cancelar",
    aoCancelarEdicaoAsAlteracoesFeitasNoGrupoSeraoPerdidas: "Al cancelar la edición, los cambios realizados en el grupo se perderán.",
    cancelarEdicaoDoGrupoDeProjetos: "¿Cancelar la edición del grupo de proyectos?",
    naoFoiPossivelBuscarOsGruposDeProjetos: "No fue posible buscar los grupos de proyectos",
    deletarGrupoDeProjetos: "borrar grupo de proyectos?",
    apenasGrupoSeraDeletado: "Solo se borrará el grupo: los proyectos seguirán activos en el sistema.",
    naoFoiPossivelDeletarGrupoDeProjetos: "No fue posible borrar el grupo de proyectos",
    grupoDeProjetosDeletados: "¡Grupo de proyectos eliminado!",
    vejaSeusProjetosEm: `Vea sus proyectos en "ver todos los proyectos"`,
  }
}
